import { Button, Dialog, DialogContent, Typography } from '@material-ui/core'
import React from 'react'

export default function DialogRegister({ open, handleClose, email }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth='md'
        >
            <DialogContent style={{ display: 'flex', flexDirection: "column", alignItems: 'center', padding: "50px" }}>
                <img style={{
                    width: '150px',
                    marginBottom: '20px',

                }} src='confirmemail.png' alt="confirmemail"></img>
                <Typography variant="h4" style={{
                    marginBottom: '30px',

                }}>
                    ระบบได้ส่งข้อความไปยังอีเมลท่านเรียบร้อยแล้ว
                </Typography>
                <Typography variant='h5' style={{
                    marginBottom: '15px',
                    color: 'green'
                }}>{email}</Typography>
                 <Typography variant="h5" component={'span'} style={{
                    marginBottom: '15px',


                }}>
                    กรุณากดยืนยันตัวตนผ่านอีเมล
                </Typography>
                <Typography variant="h5" component={'span'} style={{
                    marginBottom: '15px',


                }}>
                    เพื่อติดตามสถานะการสมัคร
                </Typography>
                <Button style={{
                    background: '#3364AF',
                    fontSize: '1.0rem',
                    width: '100%',
                    height: '45px',
                }} variant="contained" onClick={handleClose} color="primary"
                >ปิด</Button>
            </DialogContent>
        </Dialog >
    )
}
